<template>
  <div class="d-flex align-items-center filters-cont flex-wrap gap-3">
    <div class="d-flex flex-col">
      <b>Organization-Level View</b>
      <Select
        v-model="deptIds"
        class="mb-0 department-selector"
        :options="departments"
        placeholder="Company"
        :full-width="false"
        multiple
        data-cy="department-selector"
      >
        <template #item-row="{ option }">
          <div class="option-row">
            <TruncateText
              class="ml-1"
              :class="{ 'strike-through': option.archived }"
              :text="option?.label"
            />
          </div>
        </template>
      </Select>
    </div>
    <time-period-filters></time-period-filters>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import Select from "serviceshift-ui/components/Inputs/Select.vue";
import { mapActions, mapState } from "vuex";
import { getQueryVariables, updateQueryParam } from "@/lib/url.js";

import TimePeriodFilters from "@/components/TimePeriodFilters.vue";
import TruncateText from "@/components/TruncateText.vue";

export default {
  components: {
    TimePeriodFilters,
    TruncateText,
    Select
  },
  data() {
    return {
      deptIds: null
    };
  },
  computed: {
    ...mapState({
      departments: ({ departments }) => {
        const archivedDepartments = departments.filter((dept) => dept.archived);
        const unarchivedDepartments = departments.filter(
          (dept) => !dept.archived
        );
        return [...unarchivedDepartments, ...archivedDepartments].map(
          (dept) => ({
            archived: dept.archived,
            label: dept.name,
            value: dept.id
          })
        );
      }
    })
  },
  watch: {
    deptIds(newValue) {
      updateQueryParam("department_id", newValue, true);
      this.setFilters(newValue);
    },
    departments(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setDefaultFilters();
      }
    }
  },
  mounted() {
    this.fetchDepartments();
  },
  methods: {
    ...mapActions(["fetchDepartments", "setDashboardFilters"]),
    setDefaultFilters() {
      const params = getQueryVariables();
      if (params.department_id) {
        this.deptIds = params.department_id.split(",");
      }
    },
    setFilters: debounce(function (value) {
      this.setDashboardFilters({ department_id: value });
    }, 1000)
  }
};
</script>

<style lang="scss" scoped>
.department-selector {
  width: 250px;
}
:deep(.option) {
  white-space: nowrap;
}
</style>
